import type { MessageSentEventData } from "@redotech/effect-api-shared/models/shopper-ai/conversation/timeline-event/timeline-event";
import type { ConversationTimelineEventResponse } from "@redotech/effect-api-shared/models/shopper-ai/conversation/timeline-event/timeline-event-response";
import MessageIcon from "@redotech/redo-icons/message-chat-circle.svg";
import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";
import { memo } from "react";
import { EventTimestamp } from "./event-timestamp";
import * as styles from "./timeline-event.module.css";

export const MessageSentEvent = memo(function MessageSentEvent({
  event,
  data,
}: {
  event: ConversationTimelineEventResponse;
  data: MessageSentEventData;
}) {
  return (
    <Flex align="flex-start" className={styles.card} dir="row" gap="sm">
      <div className={styles.icon}>
        <MessageIcon />
      </div>
      <Flex className={styles.content} dir="column" gap="xxs">
        <Text fontSize="xs">Message sent via {data.channel}</Text>
        <EventTimestamp event={event} />
      </Flex>
    </Flex>
  );
});
